import { FormattedNumber } from 'react-intl';
import { jsx, Fragment } from 'react/jsx-runtime';

const usePrices = _ref => {
  let {
    market,
    amount,
    currency
  } = _ref;
  const roundedDecimalAmount = Math.round(amount * 100);

  // When rounded amount is 100p display value should be £1.00
  const useDecimalDenomination = market === 'GB' && currency === 'GBP' && amount < 1 && roundedDecimalAmount !== 100;
  return {
    shouldUseDecimalDenomination: useDecimalDenomination,
    amount: useDecimalDenomination ? roundedDecimalAmount : amount
  };
};
function Prices(props) {
  const {
    shouldUseDecimalDenomination,
    amount
  } = usePrices(props);
  return /*#__PURE__*/jsx(Fragment, {
    children: shouldUseDecimalDenomination ? /*#__PURE__*/jsx("span", {
      children: `${amount}p`
    }) : /*#__PURE__*/jsx(FormattedNumber, {
      value: amount,
      currency: props.currency,
      style: "currency"
    })
  });
}

export { Prices, Prices as default };
